import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PeriodicFormComponent } from './periodic-form.component';

const routes: Routes = [
  {
    path: '',
    component: PeriodicFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PeriodicFormRoutingModule {}
